export default __webpack_public_path__ + "static/media/icon-libras.fea21b8d.svg";